import { defineMessages } from 'react-intl';

export const LABEL_NORMAL = 'Standard';
export const LABEL_OPTIMAL = 'Optimal';
export const LABEL_OUT_OF_RANGE = 'Out-of-Range';
export const LABEL_LEARN_MORE = 'Learn More';

export const messages = defineMessages({
  view: {
    id: 'measurements.ranges.view',
    defaultMessage: 'View',
  },
  pending: {
    id: 'measurements.ranges.pending',
    defaultMessage: 'Pending',
  },
  learnMore: {
    id: 'measurements.ranges.learnMore',
    defaultMessage: LABEL_LEARN_MORE,
  },
  inRange: {
    id: 'measurements.ranges.inRange',
    defaultMessage: LABEL_NORMAL,
  },
  outOfRange: {
    id: 'measurements.ranges.outOfRange',
    defaultMessage: LABEL_OUT_OF_RANGE,
  },
  optimal: {
    id: 'measurements.ranges.optimal',
    defaultMessage: LABEL_OPTIMAL,
  },
  quest: {
    id: 'measurements.ranges.quest',
    defaultMessage: 'Quest',
  },
  bostonHeart: {
    id: 'measurements.ranges.bostonHeart',
    defaultMessage: 'Boston Heart',
  },
  unspecified: {
    id: 'measurements.ranges.unspecified',
    defaultMessage: 'Unspecified',
  },
  selectResult: {
    id: 'measurements.ranges.selectResult',
    defaultMessage: 'Select a result',
  },
  next: {
    id: 'measurements.ranges.next',
    defaultMessage: 'Next',
  },
  previous: {
    id: 'measurements.ranges.previous',
    defaultMessage: 'Previous',
  },
  noResults: {
    id: 'measurements.ranges.noResults',
    defaultMessage: 'No results',
  },
  comment: {
    id: 'measurements.ranges.comment',
    defaultMessage: 'Comment',
  },
  resultView: {
    id: 'measurements.ranges.resultView',
    defaultMessage: 'Result view',
  },
  personalized: {
    id: 'measurements.ranges.personalized',
    defaultMessage: 'Personalized',
  },
  standard: {
    id: 'measurements.ranges.standard',
    defaultMessage: 'Standard',
  },
});
